import Loadable from "react-loadable";
import PageLoadingSpinner from "../../components/old/form/PageLoadingSpinner";
const LazyInstallers =  Loadable({
    loader: () => import('./BillingIndex'),
    loading: PageLoadingSpinner,
});
export default LazyInstallers
